import { Modal, Paper, Typography, Button, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Spin from 'components/Spin';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { exportCDF } from 'store/Orbita/FiscalDocuments/actions';

import type { DispatchProp } from 'react-redux';
import type { IFilterParams } from 'store/Orbita/FiscalDocuments/interfaces';

const decorate = withStyles((theme) => ({
  modalReport: {
    padding: '1.5rem',
    width: '95vw',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('md')]: {
      width: 640,
    },
  },
}));

interface IProps extends DispatchProp<{}> {
  open: boolean;
  onClose: any;
  classes?: any;
  email: any;
  filterParams: IFilterParams;
  endDate: any;
  type: any;
}

class ModalReport extends Component<IProps, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      requesting: false,
      finished: false,
    };
  }

  handleSubmit = () => {
    (async () => {
      try {
        const { dispatch, filterParams } = this.props;
        await this.setState({ requesting: true });
        await dispatch(exportCDF(filterParams));
        await this.setState({ requesting: false, finished: true });
      } catch (error) {
        await this.setState({ requesting: false });
        toast.error('Ops, erro ao tentar gerar relatório!');
      }
    })();
  };

  onClose = () => {
    this.setState({
      requesting: false,
      finished: false,
    });
    this.props.onClose();
  };

  render() {
    const { classes } = this.props;
    const { requesting, finished } = this.state;

    return (
      <Modal open={this.props.open} onClose={this.props.onClose}>
        <Paper className={classes.modalReport}>
          <Typography variant='h6' style={{ color: '#192542' }}>
            Geração de relatório de documentos fiscais
          </Typography>
          <div className='m16' />
          {requesting ? (
            <Typography style={{ color: '#818B9D' }}>
              <Spin />
            </Typography>
          ) : finished ? (
            <Typography variant='subtitle2' style={{ color: '#818B9D' }}>
              Geração do relatório solicitado com sucesso, você irá receber o relatório no e-mail <b>{this.props.email}</b> quando o processo
              finalizar.
            </Typography>
          ) : (
            <Typography style={{ color: '#818B9D' }}>
              <Grid spacing={2} container>
                <Grid item xs={12}>
                  <Typography variant='subtitle2' style={{ color: '#818B9D' }}>
                    Ao gerar o relatório você irá receber uma cópia no e-mail <b>{this.props.email}</b> assim que o processo for finalizado.
                  </Typography>
                </Grid>
              </Grid>
            </Typography>
          )}
          <div className='m24' />
          <div className='m16' />
          {!requesting && (
            <div style={{ textAlign: 'right' }}>
              <Button color='default' onClick={this.onClose}>
                Fechar
              </Button>
              {!finished && (
                <Button variant='contained' color='primary' onClick={this.handleSubmit}>
                  Gerar
                </Button>
              )}
            </div>
          )}
        </Paper>
      </Modal>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    email: state.orbita.User.originalUser && state.orbita.User.originalUser.email,
  };
}

export default decorate(connect(mapStateToProps)(ModalReport)) as any;
